import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty, trim } from 'lodash';
import { formatDate } from 'utils/Formatters';
import { ReplaceTransition, CSSTransition } from 'react-transition-group';
import { ANIMATIONS } from 'utils/Animations';

export default class WebNote extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    isLast: PropTypes.bool.isRequired,
    note: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = { isEdit: false, value: this.props.note.body };
  }

  onCancel = () => {
    this.setState({ isEdit: false });
  }

  onDelete = () => {
    if (window.confirm('Are you sure you want to delete this note?')) {
      const { note, params } = this.props;
      this.props.onDelete(note.id, params);
    }
  }

  onEdit = () => {
    this.setState({ isEdit: true, value: this.props.note.body });
  }

  onChange = (e) => {
    this.setState({ value: e.target.value });
  }

  onUpdate = () => {
    const { note, params } = this.props;
    const value = this.state.value;
    this.setState({ isEdit: false });
    if (!isEmpty(trim(value)) && (value !== note.body)) {
      this.props.onUpdate(note.id, params, value);
    }
  }

  render() {
    const { auth, note, isLast } = this.props;
    const clsUpdate = classNames('o-sp-button o-sp-button--note o-sp-button--primary',
      { 'u-disabled': isEmpty(trim(this.state.value)) }
    );
    const isOwnNote = parseInt(auth.id, 10) === note.respondent.id;
    return (
      <section className='o-webnote u-margin-top--tiny'>
        <div className='u-margin-bottom--small u-txt--web-note-base'>
          Added by {note.respondent.name}
          <span className='o-webnote__delimeter'>|</span>
          {formatDate(note.updatedAt)}
          { isOwnNote && <span className='o-webnote__delimeter'>|</span> }
          { isOwnNote && <a className='cs-txt-link--sp-blue' onClick={this.onEdit}>Edit Note</a> }
          { isOwnNote && <span className='o-webnote__delimeter'>|</span> }
          { isOwnNote && <a className='cs-txt-link--sp-red' onClick={this.onDelete}>Delete Note</a> }
        </div>
        <ReplaceTransition in={this.state.isEdit}>
          <CSSTransition timeout={{ enter: ANIMATIONS.in, exit: ANIMATIONS.out }} classNames='a-fade'>
            <div className='u-txt--web-note-txt'>
              <textarea rows='6' value={this.state.value} onChange={this.onChange} />
              <div className='row align-middle'>
                <div className='column shrink'>
                  <a className={clsUpdate} onClick={this.onUpdate}>Update</a>
                </div>
                <div className='column shrink'>
                  <a className='o-sp-button--note cs-txt-link--sp-blue' onClick={this.onCancel}>Cancel</a>
                </div>
              </div>
            </div>
          </CSSTransition>
          <CSSTransition timeout={{ enter: ANIMATIONS.out, exit: ANIMATIONS.in }} classNames='a-none'>
            <p className='u-wspace--prewrap'>{note.body}</p>
          </CSSTransition>
        </ReplaceTransition>
        { !isLast && <hr className='u-hr--answer'/> }
      </section>
    )
  }
}
